import clsx, { type ClassValue } from 'clsx';

/**
 * Concaténation conditionnelle de classes.
 *
 * Pas de `tailwind-merge` volontairement : les primitives de ce paquet
 * n'exposent pas de props de style qui entreraient en conflit avec leurs
 * classes internes, la déduplication serait un coût sans bénéfice.
 */
export const cn = (...inputs: ClassValue[]): string => clsx(inputs);
